import {Button} from '@mui/material';
import React from 'react';
import {Navigate, useNavigate, useParams} from 'react-router-dom';

import {MyAppointmentsEnum} from 'presentation/constants';

import {translations} from 'presentation/translations-new';

import {BookingErrorState, BookingLoadingState} from '../../components';
import {ConfirmationBookingContent} from './ConfirmationBookingContent';

import {ConfirmationBookingProps} from './types';
import {useBookedAppointmentConfirmation} from 'presentation/modules/booking/shared/hooks/useBookedAppointmentConfirmation';

const {loadError, loading} = translations['pt-br'].commons;

const {confirmationBooking, seeMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;

export function ConfirmationBooking({flowType}: ConfirmationBookingProps) {
	const navigate = useNavigate();
	const {id} = useParams();
	const {confirmedBookAppointment, refresh, appointmentsListLoading, appointmentsListError} =
		useBookedAppointmentConfirmation(id);

	const goToMyAppointments = () => {
		navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
	};

	if (appointmentsListLoading) {
		return (
			<BookingLoadingState
				pageTitle={confirmationBooking}
				loadingText={loading}
				handleBack={goToMyAppointments}
			/>
		);
	}

	if (!id || !confirmedBookAppointment) {
		return <Navigate to={MyAppointmentsEnum.MY_APPOINTMENTS} />;
	}

	if (appointmentsListError) {
		return (
			<BookingErrorState
				pageTitle={confirmationBooking}
				errorTitle={loadError}
				handleBack={goToMyAppointments}
				handleRefresh={refresh}>
				<Button
					size="large"
					sx={{mx: 'auto', mt: 2, width: 'min-content'}}
					onClick={goToMyAppointments}>
					{seeMyAppointments}
				</Button>
			</BookingErrorState>
		);
	}

	return (
		<ConfirmationBookingContent
			bookedAppointment={confirmedBookAppointment}
			flowType={flowType}
		/>
	);
}
